module.exports = __webpack_public_path__ + "img/agent_bg11.0ce49739.png";